<template>
  <div class="setup-hub-sidebar-content">
    <setup-hub-sub-step-details-component
      v-if="!!subStep"
      :subStep="subStep"
      @back-button-clicked="subStep = null"
    />
    <setup-hub-expansion-panel
      v-else
      v-model="expandedPanel"
      @step-item-click="handleStepItemClick"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { SetupHubStepCategory } from "@/constants/setup-hub.ts";
import SetupHubExpansionPanel from "@/components/setup-hub/sidebar/content-components/SetupHubExpansionPanel.vue";
import SetupHubSubStepDetailsComponent from "@/components/setup-hub/sidebar/content-components/SetupHubSubStepDetailsComponent.vue";
import { handleNavigationInSetupHub } from "@/_helpers/utils.ts";
import type { SetupHubStepItem } from "@/_store/setup-hub.module.ts";

export default defineComponent({
  components: {
    SetupHubSubStepDetailsComponent,
    SetupHubExpansionPanel,
  },
  setup() {
    const subStep = ref<SetupHubStepItem | null>(null);
    const expandedPanel = ref<SetupHubStepCategory>(SetupHubStepCategory.BASICS);

    const handleStepItemClick = (item: SetupHubStepItem) => {
      subStep.value = item;
      handleNavigationInSetupHub(subStep.value);
    };

    return {
      handleStepItemClick,
      subStep,
      expandedPanel,
    };
  },
});
</script>

<style scoped lang="scss">
.setup-hub-sidebar-content {
  width: 400px;
  background-color: rgb(var(--v-theme-indigo-faint));
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
  min-height: 0;
}
</style>
